export const programImageContext = {
  healthcare: {
    src: "/images/program-healthcare.png",
    alt: "Doctor consulting with an elderly patient",
    context: "Compassionate healthcare consultation in a clinical setting",
  },
  education: {
    src: "/images/program-education.png",
    alt: "Students writing in notebooks in a classroom",
    context: "Students learning together in a warm, well-lit classroom",
  },
  goshala: {
    src: "/images/program-goshala.png",
    alt: "Cows in a goshala shelter",
    context: "Cattle care and animal welfare at a community goshala",
  },
  "blood-donation": {
    src: "/images/program-blood-donation.png",
    alt: "Volunteers at a community blood donation camp",
    context: "Blood donation drive with donors and medical staff",
  },
  "blanket-destitution": {
    src: "/assets/DSC01055.JPG",
    alt: "Winter relief for people in need",
    context: "Blanket distribution and shelter support for homeless individuals",
  },
  "skill-development": {
    src: "/images/program-skill-development.webp",
    alt: "Vocational skill development workshop",
    context: "Hands-on vocational and digital skills training for employability",
  },
} as const;

export type ProgramSlug = keyof typeof programImageContext;

export interface ProgramImageMeta {
  src: string;
  alt: string;
  context: string;
}

export function getProgramImageMeta(slug: string): ProgramImageMeta {
  const meta = programImageContext[slug as ProgramSlug];
  if (meta) return meta;
  return {
    src: "/assets/HealthCare-image.png",
    alt: "Community program",
    context: "Community development initiative",
  };
}

export function getProgramImageSrc(slug: string): string {
  return getProgramImageMeta(slug).src;
}

export function buildProgramAssetMap(): Record<ProgramSlug, string> {
  return Object.fromEntries(
    Object.entries(programImageContext).map(([slug, meta]) => [slug, meta.src])
  ) as Record<ProgramSlug, string>;
}
